<script setup lang="ts">
/**
 * A text block — a chapter's passage, or a math exercise's prompt (`$…$` is KaTeX). No markers (a
 * passage declares no gaps) and no audio authoring; a stored `audioUrl` is kept untouched.
 */
import type { TextBlock } from '../../../model/assessments/interfaces'
import type { AssignmentContentOwner } from '../../../model/assignments/store/interfaces'

import { useAssignmentContentBlockText } from '../../../model/assignments/content-block-editors.hook'
import AnnotatedTextarea from '../../assessments/editor/AnnotatedTextarea.vue'

defineOptions({
  name: 'ChapterBlockText',
})

const props = withDefaults(defineProps<{
  owner: AssignmentContentOwner
  index: number
  block: TextBlock
  placeholder?: string
}>(), {
  placeholder: 'The text of this chapter',
})

const { setValue } = useAssignmentContentBlockText({
  owner: () => props.owner,
  index: () => props.index,
})
</script>

<template>
  <div class="chapter-block-text">
    <AnnotatedTextarea
      :value="block.value"
      :placeholder="placeholder"
      @update:value="setValue"
    />
  </div>
</template>

<style scoped lang="scss" src="./ChapterBlockText.scss" />
